<template>
  <div class="device-control-bd">
    <el-drawer size="1000px" :title="model.title" :visible="visible" :before-close="closeDialog" class="device-control-drawer" :append-to-body="true">
      <div class="info-content">
        <div class="info-content-box">
          <div class="title" v-if="model.desc">
            <i class="icon icon-tishi"></i>
            {{ model.desc }}
          </div>
          <div class="info-box">
            <ul class="information">
              <template v-for="item in paramList">
                <li class="line" :key="item.componentCode"  v-if="item.componentCode !== 'resourcePush'">
                  <div class="l">
                    {{ item.componentName }}
                  </div>
                  <div class="m">
                    {{ item.componentDesc }}
                  </div>
                  <div class="r">
                    <!--
                      重启  设备在线时可用， 不在线时禁用该按钮
                      强制重启  设备在线时可用， 不在线时禁用该按钮
                      模式设定  设备在线时可用， 不在线时禁用该按钮
                      RFID同步 设备在线时可用， 不在线时禁用该按钮
                      更换组件 设备在线时可用， 不在线时禁用该按钮
                    -->

                    <!-- widgetType 9是按钮  7是switch  isOnline布尔型 是否在线 dataValue==='0'-->
                    <!--
                      commandMode  1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择 7-服务.固件升级
                      command_status_type   1-机器锁，2-省电模式，3-自由锁，4-账单锁，5-库存锁
                      command_status_dic_group    命令状态字典项（用于显示状态的样式）
                      是否在线 dataValue==='0'
                      字典
                        命令模式  topic_command_mode
                        命令状态类型  command_status_type

                        :disabled="!item.isOnline"
                    -->
                    <template v-if="`${item.commandMode}` === '1'">
                      <icon-img v-if="item.componentIcon" class="icon-img" :bizId="item.componentIcon" biz-type="iot.component.icon" @click.native="changeContorl(item)"></icon-img>
                      <el-button v-else @click="changeContorl(item)">
                        {{ item.componentName }}
                      </el-button>
                    </template>
                    <!-- 状态修改 -->
                    <template v-else-if="`${item.commandMode}` === '2'">
                      <div class="status-type">
                        <icon-img v-if="item.componentIcon" class="icon-img" :bizId="item.componentIcon" biz-type="iot.component.icon" @click.native="changeContorl(item)"></icon-img>
                        <span v-else :class="getDicValue(item.commandStatusDicGroup, item.dataValue, 'value3')">
                          {{ getDicValue(item.commandStatusDicGroup, item.dataValue) }}
                        </span>
                      </div>
                      <el-button type="text" @click="changeStatus(item)">{{$t('Common.com_modify')}}</el-button>
                    </template>
                    <!-- 弹框录入 -->
                    <!-- <template v-else-if="`${item.commandMode}` === '3'">
                      <icon-img v-if="item.componentIcon" class="icon-img" :bizId="item.componentIcon" biz-type="iot.component.icon" @click.native="changeSetting(item)"></icon-img>
                      <el-button v-else @click="changeSetting(item)">
                        {{ item.componentName }}
                      </el-button>
                    </template> -->
                    <!-- 直接修改状态 如:刷新topic大类 暂时写死 暂时只有刷新大类用到 后续要通过状态判断-->
                    <template v-else-if="`${item.commandMode}` === '3'">
                      <!-- {{getDictionaryItem('iot_tsl_topic_class3')}} -->
                      <el-button type="text" v-for="dic in getDictionaryItem(item.dicGroup)" :key="dic.value" @click="btnSumit({ ...item, defaultValue: dic.value })">
                        {{ dic.name }}
                      </el-button>
                    </template>
                    <!-- 固件升级 resourcePush -->
                    <template v-else-if="`${item.commandMode}` === '7'">
                      <el-button type="text"  @click="changeUpgrade(item)" >
                        {{ item.componentName }}
                      </el-button>
                    </template>
                  </div>
                </li>
                <li class="line" :key="item.componentCode" v-if="item.componentCode === 'resourcePush' && funcView.boardDetail_resourcePush">
                  <div class="l">
                    {{ item.componentName }}
                  </div>
                  <div class="m">
                    {{ item.componentDesc }}
                  </div>
                  <div class="r">
                    <!--
                      重启  设备在线时可用， 不在线时禁用该按钮
                      强制重启  设备在线时可用， 不在线时禁用该按钮
                      模式设定  设备在线时可用， 不在线时禁用该按钮
                      RFID同步 设备在线时可用， 不在线时禁用该按钮
                      更换组件 设备在线时可用， 不在线时禁用该按钮
                    -->

                    <!-- widgetType 9是按钮  7是switch  isOnline布尔型 是否在线 dataValue==='0'-->
                    <!--
                      commandMode  1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择 7-服务.固件升级
                      command_status_type   1-机器锁，2-省电模式，3-自由锁，4-账单锁，5-库存锁
                      command_status_dic_group    命令状态字典项（用于显示状态的样式）
                      是否在线 dataValue==='0'
                      字典
                        命令模式  topic_command_mode
                        命令状态类型  command_status_type

                        :disabled="!item.isOnline"
                    -->

                    <!-- 固件升级 resourcePush -->
                    <template v-if="`${item.commandMode}` === '7' ">
                        <!-- {{getDictionaryItem('iot_tsl_topic_class3')}} -->
                        <el-button type="text"  @click="changeUpgrade(item)" >
                          {{ item.componentName }}
                        </el-button>
                      </template>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </el-drawer>
    <device-changeStatus-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="updateParamList"></device-changeStatus-dialog>
    <!-- 修改配置 -->
    <device-param-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="updateParamList"></device-param-dialog>
    <!-- 升级固件 -->
    <device-changeUpgrade-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="updateParamList"></device-changeUpgrade-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import iconImg from '@/components/iconImg.vue';
import deviceChangeStatusDialog from './device_changeStatus_modem_dialog.vue';
import deviceParamDialog from './device_paramModem_dialog.vue';
import deviceChangeUpgradeDialog from './device_changeUpgrade_dialog.vue';

export default {
  components: {
    deviceChangeStatusDialog,
    deviceParamDialog,
    iconImg,
    deviceChangeUpgradeDialog
  },
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },

  data() {
    return {
      visible: false,
      paramList: [],
      // 修改状态
      dialogVisible: false,
      dialogModel: {},
      // 修改配置
      dialogVisible1: false,
      dialogModel1: {},
      // 固件升级
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  mounted() {
    this.initDrawer();
    this.getFuncView('/boarddetail');
  },
  methods: {
    // 初始化
    initDrawer: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.getParamList();
    },
    updateParamList() {
      setTimeout(() => {
        this.getParamList();
      }, 8000);
    },
    // 获取控制列表
    getParamList: function () {
      this.$getJSON(apis.modemBatteryParamItemControl, {
        modemSn: this.data.modemSn,
        componentCode: this.data.componentCode,
        testType: this.data.testType,
      }).then((res) => {
        this.paramList = res.data;
        // this.paramList.forEach(i => i.dataValue = `${i.dataValue}` || '');
        this.childComponentName = res.data[0].componentName;
        // this.structureId = res.data[0].structureId;
        // this.getParamItemList();
      });
    },

    // 按钮
    changeContorl: function (item) {
      // if (!item.isOnline) {
      //   this.$message({
      //     message: '设备不在线不能进行此操作!',
      //     type: 'error'
      //   });
      //   return;
      // }
      if (item.commandMode === 1) {
        this.$showConfirm(item.componentDesc, item.componentName)
          .then(() => {
            this.btnSumit(item);
          })
          .catch(() => {});
      }
    },
    // 修改状态
    changeStatus: function (item) {
      this.dialogModel.title = item.componentName;
      this.dialogModel.type = 'edit';
      this.dialogModel.data = {
        modemSn: this.data.modemSn,
        componentGroup: this.data.componentGroup,
        componentCode: item.componentCode,
        testType: this.data.testType,
        ...item,
      };
      this.dialogVisible = true;
    },
    // 弹框录入 修改参数弹窗
    changeSetting: function (item) {
      this.dialogModel1.title = item.componentName;
      this.dialogModel1.type = 'edit';
      this.dialogModel1.data = {
        modemSn: this.data.modemSn,
        componentGroup: this.data.componentGroup,
        componentCode: item.componentCode,
        testType: this.data.testType,
        ...item,
      };
      this.dialogVisible1 = true;
    },
    // 固件升级
    changeUpgrade: function (item) {
      this.dialogModel2.title = `${item.componentName}(${this.data.modemSn})`;
      this.dialogModel2.type = 'edit';
      this.dialogModel2.data = {
        modemSn: this.data.modemSn,
        componentGroup: this.data.componentGroup,
        componentCode: item.componentCode,
        ...item,
      };
      this.dialogVisible2 = true;
    },
    // 按钮事件
    btnSumit: function (item) {
      // 按钮下发命令将defaultValue赋值给dataValue
      // if (`${item.widgetType}` === '9') {
      //   item.dataValue = item.defaultValue;
      // }
      item.dataValue = item.defaultValue;
      item.paramValue = item.defaultValue;
      item.modemSn = this.data.modemSn;
      item.componentGroup = this.data.componentGroup;
      item.testType = this.data.testType;

      // item.structureId = this.data.structureId;
      const params = [];
      params.push(item);
      this.$postJSON(apis.modemBatteryParamItemSave, params).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.updateParamList();
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.device-control-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;
  span[role='heading']:focus {
    outline: none;
  }
  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;
    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .el-drawer__body {
    position: relative;
    padding: 0px;

    .info-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .info-content-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding: 24px !important;
        .title {
          padding-left: 10px;
          background: rgba(249, 200, 81, 0.15);
          border-radius: 2px;
          font-size: 12px;
          line-height: 32px;
          color: rgba(108, 117, 125, 1);
          .icon {
            color: rgba(249, 200, 81, 1);
            margin-right: 10px;
          }
        }
        .icon-img {
          display: block;
          width: 60px;
          height: 32px;
          cursor: pointer;
          align-self: center;
        }
        .info-box {
          width: 100%;
          padding-top: 24px;
          // margin-right: 24px;
          background-color: #fff;
          // height: 100%;
          .information {
            .line {
              height: 70px;
              line-height: 70px;
              font-size: 12px;
              font-weight: 400;
              // cursor: pointer;
              padding: 0 16px;
              display: flex;
              align-content: center;
              justify-content: center;
              border-bottom: 1px dashed rgba(228, 235, 242, 1);
              .l {
                font-size: 12px;
                font-weight: bold;
                color: rgba(73, 80, 87, 1);
                width: 238px;
                flex: 0 0 238px;
              }
              .m {
                flex: 1;
                color: rgba(152, 166, 173, 1);
              }
              .r {
                align-self: center;
                display: flex;
                align-content: center;
                .status-type {
                  align-self: center;
                  margin-right: 24px;
                  span {
                    display: inline-block;
                    font-size: 12px;
                    font-weight: 400;
                    height: 32px;
                    line-height: 32px;
                    padding: 0 16px 0 30px;
                    border-radius: 16px;
                    position: relative;

                    &::before {
                      content: ' ';
                      position: absolute;
                      left: 14px;
                      margin-top: 13px;
                      // transform: translateY(-50%);
                      display: inline-block;
                      width: 6px;
                      height: 6px;
                      border-radius: 50%;
                    }
                  }
                  .normal {
                    background-color: #f9f9f9;
                    color: #6c757d;
                    &::before {
                      background-color: #00a0d9;
                    }
                  }
                  .sleep {
                    background: rgba(147, 218, 73, 0.16);
                    color: #93da49;
                    &::before {
                      background-color: #93da49;
                    }
                  }
                  .lock {
                    background: rgba(237, 74, 74, 0.16);
                    color: #ed4a4a;
                    &::before {
                      background-color: #ed4a4a;
                    }
                  }
                  .unlock {
                    background: #f9f9f9;
                    color: #00a0d9;
                    &::before {
                      background-color: #00a0d9;
                    }
                  }
                }
                .modify {
                  cursor: pointer;
                  color: #0d9ae0;
                }
                button {
                  align-self: center;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
